import * as React from "react"
import {createRoot} from "react-dom/client";
import {flushSync} from "react-dom";
import {Skeleton} from "@mui/material";
import {BubbleAmchartSeeker} from "@ui-seeker/core";

import {TitleWithPopover} from "@components";
import {GROUPED_BY} from "@constants";
import {isLoadingCommonFilters} from "@signals";
import {isLoadingMarketPosition, marketPositionCurrentData, marketPositionTab} from "../@signals";
import MarketplacesMarketPositionTooltip from "./Tooltip";
import {translateCountryName} from "@ui-seeker/utils";
import MarketplacesGroupedByToggleButton from "./Action";


const HEIGHT = 500

const tooltipHTML = document.createElement('div');
const root = createRoot(tooltipHTML);

flushSync(() => root.render(<MarketplacesMarketPositionTooltip />))

export default function MarketPlacesMarketPosition() {
	if (isLoadingCommonFilters.value || isLoadingMarketPosition.value) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!marketPositionCurrentData.value.length) return <></>


    return <BubbleAmchartSeeker
		rootID="bubbleChart"
		title={<TitleWithPopover title="Global Market Position" />}
		data={marketPositionCurrentData.value.map(({label, ...dataProps}) => ({
			label: marketPositionTab.value === GROUPED_BY.COUNTRY ? translateCountryName(label) : label,
			...dataProps
		}))}
		series={[{
			xField: 'discount',
			yField: 'numSellers',
			value: 'numProducts',
			bullets: {
				sprite: {
					tooltipHTML: tooltipHTML.innerHTML
				}
			},
			tooltip: { forceHidden: true }
		}]}
		cardProps={{
			actions: <MarketplacesGroupedByToggleButton />
		}}
		chartProps={{
			enabledPDF: false,
			numberFormat: "#",
			cursor: {
				behavior: "none"
			},
			xAxis: {
				numberFormat: "#'%'",
				title: 'Price dispersion'
			},
			yAxis: {
				title: 'Number of sellers'
			}
		}}
	/>
}